var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeeting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.375 12.4687V6.53125C2.375 6.11132 2.54181 5.7086 2.83875 5.41166C3.13568 5.11473 3.53841 4.94792 3.95833 4.94792H10.6875C11.1074 4.94792 11.5102 5.11473 11.8071 5.41166C12.104 5.7086 12.2708 6.11132 12.2708 6.53125V12.4687C12.2708 12.8887 12.104 13.2914 11.8071 13.5883C11.5102 13.8853 11.1074 14.0521 10.6875 14.0521H3.95833C3.53841 14.0521 3.13568 13.8853 2.83875 13.5883C2.54181 13.2914 2.375 12.8887 2.375 12.4687ZM15.9663 5.53454L12.7997 8.35525C12.7579 8.39231 12.7245 8.43778 12.7016 8.48867C12.6787 8.53956 12.6668 8.59473 12.6667 8.65054V10.0581C12.6668 10.1139 12.6787 10.1691 12.7016 10.22C12.7245 10.2709 12.7579 10.3164 12.7997 10.3534L15.9663 13.1741C16.0234 13.2248 16.0939 13.2579 16.1693 13.2694C16.2447 13.281 16.3219 13.2705 16.3915 13.2392C16.4611 13.2079 16.5201 13.1572 16.5616 13.0931C16.603 13.029 16.625 12.9543 16.625 12.878V5.83063C16.625 5.75432 16.603 5.67964 16.5616 5.61557C16.5201 5.5515 16.4611 5.50077 16.3915 5.46949C16.3219 5.4382 16.2447 5.4277 16.1693 5.43924C16.0939 5.45078 16.0234 5.48388 15.9663 5.53454Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeeting);
export default __webpack_public_path__ + "static/media/meeting.b767525f7b4d7cff4f8e7afbfd6125b7.svg";
export { ForwardRef as ReactComponent };